import React from 'react';
import { FormattedMessage } from 'react-intl';

import globalTranslations from '../../../../i18n/globalTranslations';

const CheckoutPageTitle = () => (
  <h1 className="CheckoutPageTitle">
    <FormattedMessage {...globalTranslations.checkoutTitle} />
  </h1>
);

export default CheckoutPageTitle;
